<div class="agj-loading-app">
  <div class="wrapper" @fadeIn>
    <agj-liquid-loader></agj-liquid-loader>

    @if (message()) {
      <p class="message" @fadeIn>{{ message() }}</p>
    }
  </div>
</div>
